<template>
    <div>
        秒杀总库存
        <el-popover
            placement="bottom"
            width="340"
            trigger="click"
            v-model="spikeStockBatchVisible">
            <div>
                <div style="margin-bottom:8px">
                <span style="margin-right:8px;">批量改为:</span>
                    <el-input v-model="spikeStockBatchValue" style="width: 180px" @input="value=> numCheck(value, {target: this, key: 'spikeStockBatchValue'})"></el-input>
                </div>
                <div>
                <div class="f-a" style="margin-bottom:8px">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submit">确定</el-button>
                </div>
                </div>
            </div>
            <i class="el-icon-s-unfold pointer" slot="reference" style="color:#add049" v-if="mode !== 'edit'"></i>
        </el-popover>
    </div>
</template>

<script>
export default {
    props: {
        tab: {
            type: String,
            default: ''
        },
        mode: {
            type: String,
            default: 'add'
        }
    },
    data() {
        return {
            spikeStockBatchVisible: false,
            spikeStockBatchValue: undefined
        }
    },
    methods: {
        submit() {
            const params = {
                tab: this.tab === '已在活动中' ? 'tableInDiscount': 'tableDataStorageAll',
                value: this.spikeStockBatchValue
            }
            this.$emit('change', params)
            this.spikeStockBatchVisible = false
        },
        cancel() {
            this.spikeStockBatchVisible = false
        },
        // 不可输小数点
        numCheck(value, info) {
            const { target, key } = info
            let finalValue = value.replace(/[^\d]/g, '')
            if(finalValue.startsWith('0')) finalValue = undefined
            if(+finalValue === 0) finalValue = undefined
            if (!finalValue) finalValue = undefined
            target[key] = finalValue
        }
    },
}
</script>